module.exports = __webpack_public_path__ + "img/noprofile.e0cff6d4.png";